var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _vm.loading
        ? _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "64",
                  color: "primary"
                }
              })
            ],
            1
          )
        : [
            _c(
              "v-col",
              {
                attrs: {
                  cols: "12"
                }
              },
              [
                _c(
                  "card-title",
                  {
                    staticClass: "pt-0"
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "body-2 pl-md-2",
                        attrs: {
                          to: {
                            name: "downtime"
                          }
                        }
                      },
                      [_vm._v(" Back to all incidents ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-col",
              {
                staticClass: "pt-0",
                attrs: {
                  cols: "12"
                }
              },
              [
                _c(
                  "gg-card",
                  [
                    _c("gg-card-header", [_vm._v(" Details ")]),
                    _c(
                      "gg-card-text",
                      [
                        _c("v-data-table", {
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.downtime,
                            "hide-default-footer": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.affected_servers",
                              fn: function fn(_ref) {
                                var item = _ref.item
                                return _vm._l(item.affected_servers, function(
                                  server,
                                  i
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: i
                                    },
                                    [_vm._v(" " + _vm._s(server) + " ")]
                                  )
                                })
                              }
                            },
                            {
                              key: "item.status",
                              fn: function fn(_ref2) {
                                var item = _ref2.item
                                return [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mb-1",
                                      attrs: {
                                        small: "",
                                        color: _vm.statusColor(item.status)
                                      }
                                    },
                                    [_vm._v(" mdi-circle ")]
                                  ),
                                  _vm._v(" " + _vm._s(item.status) + " ")
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-col",
              {
                staticClass: "pt-8",
                attrs: {
                  cols: "12"
                }
              },
              [
                _c(
                  "h3",
                  {
                    staticClass: "mb-0"
                  },
                  [_vm._v(" Updates ")]
                )
              ]
            ),
            _vm._l(_vm.repliesSorted, function(reply) {
              return _c(
                "v-col",
                {
                  key: reply.id,
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex justify-space-between"
                          },
                          [
                            _c("div", [_vm._v(_vm._s(reply.status))]),
                            _c(
                              "div",
                              {
                                staticClass: "caption"
                              },
                              [_vm._v(_vm._s(reply.created_at))]
                            )
                          ]
                        )
                      ]),
                      _c("gg-card-text", {
                        staticClass: "text-block",
                        domProps: {
                          innerHTML: _vm._s(reply.message)
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }